var _defs, _path, _polygon, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCcVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 30.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8f8f8;}.cls-2{fill:#2866ab;}.cls-3{fill:#eda74d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.63,28.06A1.6,1.6,0,0,1,46,29.65H1.59A1.6,1.6,0,0,1,0,28.06V1.45A1.6,1.6,0,0,1,1.59-.14H46a1.6,1.6,0,0,1,1.6,1.59Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.94 19.21 19.58 19.21 21.06 10.3 23.38 10.3 21.94 19.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.65,10.3l-2.2,6.14-.27-1.32h0l-.8-4s-.07-.79-1.1-.79H9.6l0,.15a8.34,8.34,0,0,1,2.43,1l2,7.74h2.43l3.68-8.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.94,19.21h2.12L36.2,10.3H34.35a1,1,0,0,0-1.07.68l-3.45,8.27h2.39l.49-1.33h3Zm-2.58-3.15,1.21-3.33.69,3.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,12.46l.34-1.94a6.8,6.8,0,0,0-2.08-.38c-1.14,0-3.91.5-3.91,3s3.22,2.36,3.22,3.53-2.88,1-3.83.23l-.34,2a6.45,6.45,0,0,0,2.62.5c1.59,0,4-.84,4-3.08s-3.26-2.54-3.26-3.53S29,11.89,30,12.46Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.18,15.12l-.8-4s-.07-.79-1.1-.79H9.6l0,.15A9.39,9.39,0,0,1,13,12.19,6.85,6.85,0,0,1,15.18,15.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcVisa);
export default __webpack_public_path__ + "static/media/cc-visa.dca7230ab4cecb3592f57c49fd3e9fdd.svg";
export { ForwardRef as ReactComponent };